import React, { useState } from 'react';
import './NotificationBanner.css';

export const BANNER_STORAGE_KEY = 'flipal-dev-banner-dismissed';
export const BANNER_STORAGE_HASH_KEY = 'flipal-dev-banner-dismissed-hash';

export const BANNER_TEXT_RAW = `📖 Recommended Reading: I personally own and read Pinball: A Quest for Mastery by Tasker Smith. If there was a college course for Pinball, this would be the textbook. I highly recommend this book! (Affiliate link — helps support this site)`;

// Simple hash function to detect content changes
export const getHash = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash).toString(36);
};

export const checkIsBannerDismissed = () => {
  try {
    const currentHash = getHash(BANNER_TEXT_RAW.trim());
    const dismissedHash = localStorage.getItem(BANNER_STORAGE_HASH_KEY);
    const oldDismissedTime = localStorage.getItem(BANNER_STORAGE_KEY);

    if (dismissedHash === currentHash) {
      return true;
    } else if (!dismissedHash && oldDismissedTime) {
      // Migrate old users who dismissed the banner previously with same content
      localStorage.setItem(BANNER_STORAGE_HASH_KEY, currentHash);
      localStorage.removeItem(BANNER_STORAGE_KEY);
      return true;
    }
  } catch (e) {}
  return false;
};

export const markBannerDismissed = () => {
  try {
    const currentHash = getHash(BANNER_TEXT_RAW.trim());
    localStorage.setItem(BANNER_STORAGE_HASH_KEY, currentHash);
  } catch (e) {}
};

/**
 * Shared banner content component
 */
export function NotificationBannerContent() {
  return (
    <span className="banner-text">
      📖 <strong>Recommended Reading:</strong> I personally own and read{' '}
      <a
        href="https://amzn.to/4ql9zKU"
        target="_blank"
        rel="noopener noreferrer"
        className="banner-link"
      >
        Pinball: A Quest for Mastery
      </a>{' '}
      by Tasker Smith. If there was a college course for Pinball, this would be the textbook. I highly recommend this book! <em>(Affiliate link — helps support this site)</em>
    </span>
  );
}

/**
 * Dismissible notification banner for developer job search
 * Appears at the top of the page and remembers dismissal state based on content version
 */
function NotificationBanner({ isDismissed, onDismiss }) {
  const [localDismissed, setLocalDismissed] = useState(() => checkIsBannerDismissed());

  const dismissed = isDismissed !== undefined ? isDismissed : localDismissed;

  const handleDismiss = () => {
    markBannerDismissed();
    setLocalDismissed(true);
    if (onDismiss) {
      onDismiss();
    }
  };

  if (dismissed) {
    return null;
  }

  return (
    <div className="notification-banner">
      <div className="banner-content">
        <div className="banner-message">
          <NotificationBannerContent />
        </div>
        <button
          className="banner-dismiss"
          onClick={handleDismiss}
          aria-label="Dismiss notification"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default NotificationBanner;